import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Card from "../../common/Card";
import { useTranslation } from "react-i18next";
import thumbnailPlaceholder from "../../../assets/images/thumbnail-placeholder.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CircularProgress from "../../common/CircularProgress";
import { Link } from "react-router";
import moment from "moment-timezone";
import "moment/locale/tr";

const formatDateHelper = (date, locale = "en") => {
  return moment(date).locale(locale).format("LLL");
};

export default function VideoListCard({ title, videos, isPublished }) {
  const { t, i18n } = useTranslation();
  return (
    <Card
      title={
        <div className="flex items-center justify-between p-4">
          <div className="font-semibold text-lg">{t(title)}</div>
          <Link
            to={`/ai-video/list${
              isPublished !== undefined ? `?isPublished=${isPublished}` : ""
            }`}
            className="text-sm text-empower-500 hover:text-empower-600 font-medium"
          >
            {t("view all")}
          </Link>
        </div>
      }
    >
      <Card.Body>
        <div className="flex flex-col items-center justify-stretch gap-2">
          {videos.map((video) => (
            <div
              key={`video-${video.id}-${video.creationId}`}
              className="flex items-center justify-between w-full gap-2 p-2"
            >
              <div className="flex items-center justify-center">
                <img
                  src={video.thumbnail || thumbnailPlaceholder}
                  alt={video.title || t("untitled")}
                  className="w-16 h-12 object-cover rounded"
                />
              </div>
              <div className="flex flex-col items-start justify-start flex-1">
                <div className="text-lg font-semibold text-gray-600 truncate">
                  {formatDateHelper(video.createdAt, i18n.language)}
                </div>
                <div className="flex items-center w-full gap-2">
                  <div className="text-sm text-gray-500 truncate">
                    {video.template}
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-center justify-start gap-2">
                <CircularProgress
                  percentage={Number(video.progress) * 100}
                  size={40}
                  strokeWidth={4}
                  color="text-empower-500"
                  backgroundColor="text-gray-200"
                  className="w-10 h-10"
                  fontSize={10}
                />
                <Link to={`/ai-video/${video.id}`}>
                  <FontAwesomeIcon icon={faArrowRight} size="sm" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
}
